export default "/images/23d2c426dda3e978c50f86f5fc1f3b60.png";